/**
 * File: userFilter.js
 * Project: educore
 * Created Date: 2019-03-18
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class UserFilterController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, authService, MEDICALCONSTANT) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        $scope.stateId = "userProfile"
        $scope.reqObj = {}
        $scope.personList = []
        $scope.isSelected = false

        $scope.clearParentFields = function() {
            $scope.userNamesEndorsed = []
            $scope.userEndorsedAcademic = []
            $scope.userNotEndorsedAcademic = []
            $scope.userNamesNotEndorsed = []
        }

        function clearFields() {
            $scope.pager = {};
            $scope.setPage = setPage;
            $scope.pageIndex = [];
        }

        $scope.searchValuesBasedOnFilter = function() {

            if (this.filterObj === undefined || this.filterObj.role_id === undefined) {
                toastr.error('Please Select the Role')
                return false;
            } else if (this.filterObj === undefined || this.filterObj['session'] === undefined) {
                toastr.error('Please Select the Session')
                return false;
            } else if (this.filterObj === undefined || this.filterObj['curriculum'] === undefined) {
                toastr.error('Please Select the Curriculum')
                return false;
            } else if (this.filterObj === undefined || this.filterObj['xclass'] === undefined || this.filterObj['xclass'].length <= 0) {
                toastr.error('Please Select the Class')
                return false;
            } else if (this.filterObj === undefined || this.filterObj['batch'] === undefined || this.filterObj['batch'].length <= 0) {
                toastr.error('Please Select the Batch')
                return false;
            }

            //setFilterValue(this.filterObj)

            $scope.reqObj.roleId = this.filterObj.role_id
            $scope.reqObj.sessionId = this.filterObj.session
            $scope.reqObj.curriculumId = this.filterObj.curriculum
            $scope.reqObj.classId = this.filterObj.xclass
            $scope.reqObj.batchId = this.filterObj.batch
            $scope.reqObj["school_id"] = localStorageService.get('school_id')
            $scope.getUsersLists();
        }
        $scope.getUsersLists = () => {
            $scope.loading = true;
            authService.callAPI(MEDICALCONSTANT.API_POST_GET_ALL_USERS, "POST", $scope.reqObj, (response) => {
                if (response.result && response.result.data) {
                    $scope.userNames = response.result.data.users
                    $scope.loading = false;
                    $scope.UniqueNoText = ($scope.reqObj.roleId === "student") ? "Admission No" : "Employee No"
                    _.defer(function() {
                        $scope.$apply();
                    });
                } else {
                    $scope.loading = false;
                    toastr.error('Server Interpreted.Please try after some time.')
                }
            })
        }
        $scope.toggleUnSelectAllUser = () => {
                _.each($scope.userNames, function(data) {
                    data.is_selected = $scope.isSelected ? false : true
                })
                console.log($scope.userNames)
            }
            /*
             * To navigate to user dashboard
             * 
             * @user_obj : Object - user details
             * 
             * @return : null
             */
        $scope.navigateUserDashboard = function() {
            let userIdArray = []
            _.each($scope.userNames, function(eachUser) {
                if (eachUser.is_selected === true)
                    userIdArray.push({
                        "patient_id": eachUser._id,
                        "role": eachUser.role
                    })
            })
            if (userIdArray.length === 0) {
                toastr.error('Please Select user')
            } else {
                localStorageService.set('selectedUsers', userIdArray)
                $state.go('userProfile');
            }
        }
    }
}

export default UserFilterController



// WEBPACK FOOTER //
// ./src/app/medical/controllers/userFilter.js